import React from 'react'
import { connect } from 'react-redux'
import stylesPc from './styles/howtoPageStyle'
import stylesPhone from './styles/howtoPageStyleSmartPhone.js'
import howtoImgPC from '../../res/img/howToPC.png'
import howtoImgMobile from '../../res/img/howToMobile.png'

var styles;

type Props = {
};

type State = {
};

class HowToPage extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.state = {
        };
    }

    shouldComponentUpdate(nextProps: Object) {
        return this.props.isStart === nextProps.isStart;
    }

    reloadPage(): Function {
        window.location.reload()
    }
    
    render() {
        var isPc = this.props.screenwidth > 400 * 2;
        styles = isPc ? stylesPc : stylesPhone;
        return (
            <div style={styles.main}>
                <img style={styles.image} src={isPc ? howtoImgPC : howtoImgMobile} alt="howto" />
                <button style={styles.buttonBack} onClick={() => this.reloadPage()}>戻る</button>
            </div>
        );
    }
}

HowToPage.defaultProps = {
}
const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(HowToPage);